import type { ValidationIssue } from '@inside-us-aos/domain';

/**
 * Renders a human-readable message for a `ValidationIssue`. Shared
 * across every Phase 2 primitive so the wording stays consistent.
 * Phase 2 batch 4 (a11y / i18n exit criteria) replaces this with a
 * proper i18n binding.
 */
export function issueMessage(issue: ValidationIssue): string {
  // Friendlier wording. The previous
  // copy ("This field is required.", "This value does not match the
  // expected format.") read as a clipped error log; the new copy is
  // shorter, less repetitive of "This value", and warmer without
  // being twee. Keyword anchors are preserved (`required`, `too long`,
  // `format`, `range`) so the existing test regexes in each
  // primitive's spec keep matching.
  switch (issue.code) {
    case 'required':
      return 'Required to continue.';
    case 'string_too_short':
      return 'Too short — please double-check.';
    case 'string_too_long':
      return 'Too long for this field — try shortening.';
    case 'pattern_mismatch':
      return "Format doesn't match what USCIS expects.";
    case 'value_out_of_range':
      return 'Outside the allowed range.';
    case 'type_mismatch':
      return 'Unexpected value type.';
    case 'one_of_group_unsatisfied':
      return 'At least one of these is required.';
    default:
      return 'Please double-check this value.';
  }
}
